import { motion } from "framer-motion";

/**
 * Masked, line-by-line reveal — signature on-load moment.
 * Each child line slides up from below a mask with staggered delay.
 * Usage:
 *   <RevealText delay={0.1}>
 *     <span>Line one</span>
 *     <span>Line two</span>
 *   </RevealText>
 */
const BLOCK = { display: "block" };
const MASK = { display: "block", overflow: "hidden" };
const LINE = { display: "block", willChange: "transform" };
const FROM = { y: "110%" };
const TO = { y: "0%" };
const EASE = [0.22, 1, 0.36, 1];

export function RevealText({ children, delay = 0, className = "" }) {
  const items = Array.isArray(children) ? children : [children];
  return (
    <span className={className} style={BLOCK}>
      {items.map((el, i) => (
        <span key={typeof el === "string" ? el : el?.key || `reveal-${i}`} style={MASK}>
          <motion.span
            style={LINE}
            initial={FROM}
            animate={TO}
            transition={{ duration: 0.9, delay: delay + i * 0.09, ease: EASE }}
          >
            {el}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function FadeIn({ children, delay = 0, y = 24, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Marquee({ children, speed = 40 }) {
  return (
    <div style={{ overflow: "hidden", whiteSpace: "nowrap" }}>
      <motion.div
        style={{ display: "inline-flex", gap: 40, willChange: "transform" }}
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: speed, repeat: Infinity, ease: "linear" }}
      >
        {children}
        {children}
      </motion.div>
    </div>
  );
}
